import React, { Component } from "react";
import swal from "@sweetalert/with-react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { checkPermission, checkForTireView } from "../../../Helper";
import moment from "moment";
import Select from "react-select";
import AddTicket from "../supportOverview/components/addTicket";
import DatePicker from "react-datepicker";
import "../supportOverview/myReactSelect.css";
import NumberFormat from "react-number-format";
import { Button, Col, Form, Label } from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "../supportOverview/formsTable.css";
import { Modal } from "react-bootstrap";
import "../supportOverview/baseForms.css";
import axios from "axios";
import { baseurl } from "../../../baseurl";
var thisContex;
var token = localStorage.getItem("token");
var username = localStorage.getItem("username");
function indexN(cell, row, enumObject, index) {
  return <div>{index + 1}</div>;
}
let companyId = localStorage.getItem("companyId");
class Items extends Component {
  constructor(props) {
    super(props);
    this.hsandleChange = this.handleChange.bind(this);
    this.handleChangeEdit = this.handleChangeEdit.bind(this);
    ////////////////////////
    this.state = {
      showModalAddNew: false,
      data: [],
      permission: true,
      rolesPermission: false,
      itemAdd: "",
      showModalOpen: false,
      showItemForm: false,
      tableData: [],
      statusLov: "",
      statusId: "",
      isLoadedTableData: false,
      defaultSalesTaxOptions: [],
      defaultQuanShow: "0",
      defaultRateShow: "0",
      snd_dte_time: "0",
      activity: props?.propData?.location?.rowData?.referencePk,
    };
    thisContex = this;
  }
  showUpdateModal = (cell, row) => {
    this.setState({
      showItemForm: !this.state.showItemForm,
      row_id: row?.ticket_id,
      updateCheck: 1,
    });
    this.updateModalToggle();
  };
  updateModalToggle = () => {
    this.setState({
      UpdateModal: !this.state.UpdateModal,
    });
  };
  searchStatus = () => {
    axios
      .post(
        `${baseurl}/Support/getSuppTicket`,
        {
          companyId: companyId,
          username: username,
          statusId: this.state?.statusId?.id || "",
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let pushDataArray = [];

        let getItemData = res.data.data;
        for (let i = 0; i < getItemData.length; i++) {
          let ticket_id = getItemData[i]["ticket_id"];
          let ticket_no = getItemData[i]["ticket_no"];
          let ticket_dt = moment(getItemData[i]["ticket_dt"]).format(
            "DD-MMM-YYYY hh:mm a"
          );
          let tick_type = {
            id: getItemData[i]["ticket_type_id"],
            label: getItemData[i]["ticket_type_desc"],
          };
          let tick_type_desc = getItemData[i]["ticket_type_desc"];
          let userIp = getItemData[i]["ip"];
          let username = getItemData[i]["created_by"];
          let cntctPers = getItemData[i]["contact_person"];
          let module_desc = getItemData[i]["module_desc"];
          let short_desc = getItemData[i]["short_desc"];
          let mod_type = {
            id: getItemData[i]["module_id"],
            label: getItemData[i]["module_desc"],
          };
          let snd_dte_time = getItemData[i]["snd_dte_time"];
          let ticket_detail = getItemData[i]["ticket_detail"];
          let statusValue = getItemData[i]["status_id"];

          if (statusValue === 1) {
            statusValue = "Pending";
          } else if (statusValue === 2) {
            statusValue = "Completed By Client";
          } else if (statusValue === 3) {
            statusValue = "Cancelled By Client";
          } else if (statusValue === 4) {
            statusValue = "Completed By Accmen";
          } else if (statusValue === 5) {
            statusValue = "Cancelled By Accmen";
          } else if (statusValue === 6) {
            statusValue = "Hold By Client";
          } else if (statusValue === 7) {
            statusValue = "Removed Due To Negative Comment";
          } else {
            statusValue = "Not Sent";
          }
          pushDataArray.push({
            ticket_id: ticket_id,
            ticket_no: ticket_no,
            ticket_dt: ticket_dt,
            tick_type: tick_type,
            tick_type_desc: tick_type_desc,
            module_desc: module_desc,
            userIp: userIp,
            username: username,
            cntctPers: cntctPers,
            mod_type: mod_type,
            statusValue: statusValue,
            short_desc: short_desc,
            snd_dte_time: snd_dte_time,
            ticket_detail: ticket_detail,
          });
        }
        this.setState({
          isLoadedTableData: true,
          tableData: pushDataArray,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  itemLoad = () => {
    this.setState({
      row_id: "-1",
      showItemForm: !this.state.showItemForm,
    });
    this.getData();
  };

  handleChangeLovsSelect = (statusId) => {
    this.setState({
      statusId,
      statusName: statusId?.label,
    });
    this.searchStatus(statusId);
  };

  searchStatus = (statusId) => {
    // console.log("---sdadas----", statusId);
    axios
      .post(
        `${baseurl}/Support/getSuppTicket`,
        {
          companyId: companyId,
          username: username,
          statusId: statusId?.id || "",
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let pushDataArray = [];

        let getItemData = res.data.data;
        for (let i = 0; i < getItemData.length; i++) {
          let ticket_id = getItemData[i]["ticket_id"];
          let ticket_no = getItemData[i]["ticket_no"];
          let ticket_dt = moment(getItemData[i]["ticket_dt"]).format(
            "DD-MMM-YYYY hh:mm a"
          );
          let tick_type = {
            id: getItemData[i]["ticket_type_id"],
            label: getItemData[i]["ticket_type_desc"],
          };
          let tick_type_desc = getItemData[i]["ticket_type_desc"];
          let userIp = getItemData[i]["ip"];
          let username = getItemData[i]["created_by"];
          let cntctPers = getItemData[i]["contact_person"];
          let module_desc = getItemData[i]["module_desc"];
          let short_desc = getItemData[i]["short_desc"];
          let mod_type = {
            id: getItemData[i]["module_id"],
            label: getItemData[i]["module_desc"],
          };
          let snd_dte_time = getItemData[i]["snd_dte_time"];
          let ticket_detail = getItemData[i]["ticket_detail"];
          let statusValue = getItemData[i]["status_id"];

          if (statusValue === 1) {
            statusValue = "Pending";
          } else if (statusValue === 2) {
            statusValue = "Completed By Client";
          } else if (statusValue === 3) {
            statusValue = "Cancelled By Client";
          } else if (statusValue === 4) {
            statusValue = "Completed By Accmen";
          } else if (statusValue === 5) {
            statusValue = "Cancelled By Accmen";
          } else if (statusValue === 6) {
            statusValue = "Hold By Client";
          } else if (statusValue === 7) {
            statusValue = "Removed Due To Negative Comment";
          } else {
            statusValue = "Not Sent";
          }
          pushDataArray.push({
            ticket_id: ticket_id,
            ticket_no: ticket_no,
            ticket_dt: ticket_dt,
            tick_type: tick_type,
            tick_type_desc: tick_type_desc,
            module_desc: module_desc,
            userIp: userIp,
            username: username,
            cntctPers: cntctPers,
            mod_type: mod_type,
            statusValue: statusValue,
            short_desc: short_desc,
            snd_dte_time: snd_dte_time,
            ticket_detail: ticket_detail,
          });
        }
        this.setState({
          isLoadedTableData: true,
          tableData: pushDataArray,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  setSend = (row) => {
    let rowId = row.ticket_id;
    let tempThis = this;
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to 'Edit' this after 'Sending' it",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Send It!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${baseurl}/Support/getSendSuppTicket`,

            {
              Id: rowId,
              username: username,
              companyId: companyId,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            Swal.fire(
              "Sent!",
              "Your Ticket has been Sent to Accmen.",
              "success"
            );
            tempThis.getData();
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              button: "Try Again!",
            });
          });
      }
    });
  };

  setCancel = (row) => {
    let rowId = row.ticket_id;
    let tempThis = this;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Cancel it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${baseurl}/Support/getCancelSuppTicket`,

            {
              Id: rowId,
              status_id: 3,
              username: username,
              companyId: companyId,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            Swal.fire("Canceled!", "Your Ticket has been canceled.", "success");
            tempThis.getData();
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              button: "Try Again!",
            });
          });
      }
    });
  };
  setDelete = async (row) => {
    // const deleteCheck = await this.asyncRollCheck(3);
    // if (deleteCheck) {
    //   return;
    // }
    let rowId = row.ticket_id;
    let tempThis = this;
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .post(
            `${baseurl}/Support/getDelSuppTicket`,

            {
              Id: rowId,
              username: username,
              companyId: companyId,
            },
            {
              headers: {
                authorization: token,
              },
            }
          )
          .then((response) => {
            Swal.fire("Deleted!", "Your Record has been deleted.", "success");
            tempThis.getData();
          })
          .catch((err) => {
            console.log(err);
            swal({
              title: "Failed!",
              text: "Internet Problem",
              icon: "error",
              button: "Try Again!",
            });
          });
      }
    });
  };
  orderDetHandler = (cell, row) => {
    const { rolesPermission } = this.state;
    return (
      <div>
        <span>
          {row.snd_dte_time == null ? (
            <Button
              style={{ margin: "3px" }}
              type="submit"
              size="sm"
              color="primary"
              disabled={rolesPermission}
              onClick={() => this.showUpdateModal(cell, row)}
            >
              Edit
            </Button>
          ) : (
            ""
          )}
        </span>
        <span>
          {row.statusValue !== "Cancelled By Client" &&
            row.statusValue !== "Removed Due To Negative Comment" &&
            row.statusValue !== "Completed By Client" &&
            row.statusValue !== "Cancelled By Accmen" && (
              <Link
                to={{
                  pathname: "/viewDetails",
                  state: { cell: "value1", row: row },
                }}
                className="btn btn-outline-success mr-1"
              >
                {row.snd_dte_time == null ? (
                  <i className="fa fa-eye" aria-hidden="true" />
                ) : (
                  "Respond"
                )}
              </Link>
            )}
        </span>
        <span>
          {row.snd_dte_time == null ? (
            <Button
              style={{ margin: "3px" }}
              type="submit"
              size="sm"
              color="success"
              onClick={() => this.setSend(row)}
              disabled={rolesPermission}
              title="Send Ticket"
            >
              Send
            </Button>
          ) : (
            ""
            // <Button
            //   style={{ margin: "3px" }}
            //   type="submit"
            //   size="sm"
            //   color="success"
            //   onClick={() => this.setSend(row)}
            //   disabled={true}
            //   title="Ticket has been Sent"
            // >
            //   Send
            // </Button>
          )}
        </span>
        {row.snd_dte_time != null ? (
          <span>
            <Button
              style={{ margin: "3px" }}
              type="submit"
              size="sm"
              color="warning"
              onClick={() => this.setCancel(row)}
              disabled={
                row.statusValue == "Cancelled By Client" ||
                row.statusValue == "Removed Due To Negative Comment" ||
                row.statusValue == "Cancelled By Accmen" ||
                row.statusValue == "Completed By Client"
                  ? true
                  : false
              }
            >
              {row.statusValue == "Cancelled By Client" ||
              row.statusValue == "Removed Due To Negative Comment" ||
              row.statusValue == "Cancelled By Accmen"
                ? "Cancelled"
                : row.statusValue == "Completed By Client"
                ? "Completed"
                : "Cancel"}
            </Button>
          </span>
        ) : (
          ""
        )}
        <span></span>
      </div>
    );
  };
  toggleAddNew = () => {
    this.setState({
      showItemForm: !this.state.showItemForm,
    });
  };
  toggleOpen = () => {
    this.setState({ showModalOpen: !this.state.showModalOpen });
  };
  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleChangeEdit(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  addToggle = () => {
    this.setState({
      itemAdd: "",
    });
    this.toggleAddNew();
  };
  showDetailsModel = (cell) => {
    this.toggleOpen();
  };
  async componentDidMount() {
    // await this.asyncRollCheck(0);
    if (this.state.permission) this.getData();
    this.openNewTicketFromHeader();
  }
  componentDidUpdate(prevProps) {
    // the header Help link can be clicked while this screen is already open
    if (prevProps.location?.key !== this.props.location?.key) {
      this.openNewTicketFromHeader();
    }
  }
  // Header "Help > Raise a support ticket" navigates here with
  // state.openNewTicket; open the same form as the Generate Ticket button.
  openNewTicketFromHeader = () => {
    if (this.props.location?.state?.openNewTicket && !this.state.showItemForm) {
      this.setState({ row_id: "-1", showItemForm: true });
    }
  };
  asyncRollCheck = async (value) => {
    let pathname = "/clientTicketOverview";
    let status = value;

    let hasPermission = await checkPermission(pathname, status);
    if (hasPermission) {
      return true;
    }
  };
  getData() {
    axios
      .post(
        `${baseurl}/adminSupport/getStatusType`,

        { companyId: companyId, username: username },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then(function (response) {
        let mydata = [];
        let responseData = response.data.data;
        for (let loop = 0; loop < responseData.length; loop++) {
          mydata.push({
            id: responseData[loop]["status_id"],
            label: responseData[loop]["status_desc"],
            value: responseData[loop]["status_desc"],
          });
        }
        thisContex.setState({
          statusLov: mydata,
        });
      })
      .catch(function (error) {
        console.log(error);
      });
    thisContex.setState({ loadingResponce: true });

    axios
      .post(
        `${baseurl}/Support/getSuppTicket`,
        {
          companyId: companyId,
          username: username,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        let pushDataArray = [];

        let getItemData = res.data.data;
        for (let i = 0; i < getItemData.length; i++) {
          let ticket_id = getItemData[i]["ticket_id"];
          let attach_desc = getItemData[i]["attach_desc"];
          let attach_url = getItemData[i]["attach_url"];
          let ticket_no = getItemData[i]["ticket_no"];
          let ticket_dt = moment(getItemData[i]["ticket_dt"]).format(
            "DD-MMM-YYYY hh:mm a"
          );
          let dynamic_date_time = moment(
            getItemData[i]["dynamic_date_time"]
          ).format("DD-MMM-YYYY hh:mm a");
          let tick_type = {
            id: getItemData[i]["ticket_type_id"],
            label: getItemData[i]["ticket_type_desc"],
          };
          let tick_type_desc = getItemData[i]["ticket_type_desc"];
          let userIp = getItemData[i]["ip"];
          let username = getItemData[i]["created_by"];
          let cntctPers = getItemData[i]["contact_person"];
          let module_desc = getItemData[i]["module_desc"];
          let short_desc = getItemData[i]["short_desc"];
          let mod_type = {
            id: getItemData[i]["module_id"],
            label: getItemData[i]["module_desc"],
          };
          let snd_dte_time = getItemData[i]["snd_dte_time"];
          let ticket_detail = getItemData[i]["ticket_detail"];
          let statusValue = getItemData[i]["status_id"];

          if (statusValue === 1) {
            statusValue = "Pending";
          } else if (statusValue === 2) {
            statusValue = "Completed By Client";
          } else if (statusValue === 3) {
            statusValue = "Cancelled By Client";
          } else if (statusValue === 4) {
            statusValue = "Completed By Accmen";
          } else if (statusValue === 5) {
            statusValue = "Cancelled By Accmen";
          } else if (statusValue === 6) {
            statusValue = "Hold By Client";
          } else if (statusValue === 7) {
            statusValue = "Removed Due To Negative Comment";
          } else {
            statusValue = "Not Sent";
          }
          pushDataArray.push({
            attach_url: attach_url,
            ticket_id: ticket_id,
            attach_desc: attach_desc,
            ticket_no: ticket_no,
            ticket_dt: ticket_dt,
            dynamic_date_time: dynamic_date_time,
            tick_type: tick_type,
            tick_type_desc: tick_type_desc,
            module_desc: module_desc,
            userIp: userIp,
            username: username,
            cntctPers: cntctPers,
            mod_type: mod_type,
            statusValue: statusValue,
            short_desc: short_desc,
            snd_dte_time: snd_dte_time,
            ticket_detail: ticket_detail,
          });
        }
        this.setState({
          isLoadedTableData: true,
          tableData: pushDataArray,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    const { tableData, showItemForm, isLoadedTableData, statusId } = this.state;

    const options = {
      paginationShowsTotal: tableData.length,
      page: 1,
      sizePerPage: 5,
      pageStartIndex: 1,
      paginationSize: 5,
      prePage: "Prev",
      nextPage: "Next",
      firstPage: "First",
      lastPage: "Last",
      prePageTitle: "Go to previous",
      nextPageTitle: "Go to next",
      firstPageTitle: "Go to first",
      lastPageTitle: "Go to Last",
      paginationPosition: "top",
      sizePerPageList: [
        {
          text: "10",
          value: 10,
        },
        {
          text: "20",
          value: 20,
        },
        {
          text: "30",
          value: 30,
        },
        {
          text: "All",
          value: tableData.length,
        },
      ],
    };
    return (
      <div className="animated fadeIn">
        <>
          <div className="O-V-heading-bar">
            <div className="col-xs-8 col-md-6 mt-2">
              <strong>
                <h4>Client Ticket Overview</h4>
              </strong>
            </div>

            <div className="col-xs-4 col-md-6 mt-1">
              <>
                <Link to="/Dashboard" className="float-right mt-2">
                  <u className="Back-to-Overview text-dark">Back to Home</u>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    fill="currentColor"
                    color="black"
                    className="bi bi-chevron-left mx-2 "
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                    />
                  </svg>
                </Link>
              </>
            </div>
          </div>
        </>

        <div className="animated fadeIn">
          <div className="rowStyling mt-1">
            <Col>
              <div className="row">
                <div className="col-md-4" style={{ marginBottom: "12px" }}>
                  <Label style={{ fontWeight: "bold" }}>Status :</Label>
                  <Select
                    value={statusId || ""}
                    onChange={this.handleChangeLovsSelect}
                    options={this.state.statusLov}
                    required
                    isClearable
                    name="status"
                    id="status"
                  />
                </div>
                {/* <div className="col-md-4" style={{ marginTop: "2rem" }}>
                    <button
                      class="btn btn-warning"
                      onClick={() => this.searchStatus()}
                    >
                      <i class="fa fa-search pr-2 " aria-hidden="true" />
                      Search
                    </button>
                  </div> */}
                <div className="col-md-8" style={{ marginTop: "1.5rem" }}>
                  <span
                    style={{
                      textAlign: "right",
                      padding: "6px",
                      float: "right",
                    }}
                  >
                    <button
                      class="btn btn-outline-success rounded-pill "
                      onClick={() => this.itemLoad()}
                    >
                      <i class="fa fa-plus pr-2 " aria-hidden="true" />
                      Generate Ticket
                    </button>
                  </span>
                </div>
              </div>
              <div>
                {/* my main data table loaded after my 1st call by function of did mount getLeaveApplicationMain*/}
                <div>
                  {isLoadedTableData ? (
                    <BootstrapTable
                      data={tableData}
                      striped
                      pagination
                      hover
                      search
                      tableHeaderClass="rpr_header"
                      tableBodyClass="rpr_body"
                      containerClass="rpr_container"
                      options={options}
                    >
                      <TableHeaderColumn
                        dataField="ticket_no"
                        dataAlign="center"
                        dataSort={true}
                        width="5%"
                      >
                        TICK NO
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="dynamic_date_time"
                        dataAlign="center"
                        wrapperClassName="datePicker"
                        width="10%"
                        isKey={true}
                      >
                        TICKET DATE/TIME
                      </TableHeaderColumn>

                      <TableHeaderColumn
                        dataAlign="center"
                        dataField="tick_type_desc"
                        width="8%"
                      >
                        TICKET TYPE
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataField="short_desc"
                        dataAlign="center"
                        width="17%"
                      >
                        SHORT DESC
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataAlign="center"
                        dataField="statusValue"
                        width="12%"
                      >
                        STATUS
                      </TableHeaderColumn>
                      <TableHeaderColumn
                        dataAlign="center"
                        dataField="ITEM_ID"
                        width="10%"
                        dataFormat={this.orderDetHandler}
                      >
                        ACTION
                      </TableHeaderColumn>
                    </BootstrapTable>
                  ) : (
                    " Loading..."
                  )}
                </div>
              </div>
            </Col>
          </div>
        </div>

        {showItemForm ? (
          <>
            <AddTicket toggle={this.itemLoad} EditData={this.state.row_id} />
          </>
        ) : null}
      </div>
    );
  }
}
export default Items;
